module.exports = __webpack_public_path__ + "static/wave-a5c108e0f2775b76dad609b0bdf08011.png";